import { SliderButton } from '@/shared/uikit/components/button/sliderButton';
import { Carousel } from '@mantine/carousel';
import { useState } from 'react';

const timeItems = [
	{
		label: 'До конца дня',
		value: null,
	},
	{ label: '+30 мин', value: 30 },
	{ label: '+45 мин', value: 45 },
	{ label: '+1 час', value: 60 },
	{ label: '+2 часа', value: 120 },
];

type TimeSliderProps = {
	data?: {
		label: string;
		value: number | null;
	}[];
	disabled?: boolean;
	setTime: (minutes: number, isFullDay?: boolean) => void;
};

export const TimeSlider = ({ data, disabled, setTime }: TimeSliderProps) => {
	const [currentTab, setCurrentTab] = useState<number | null>(null);

	const handleAddTime = (minutes: number, idx: number) => {
		if (currentTab !== idx) {
			if (!minutes) {
				setTime(minutes, true);
				setCurrentTab(idx);
				return;
			}

			setTime(minutes);
			setCurrentTab(idx);
			return;
		}
		setTime(0);
		setCurrentTab(null);
	};

	return (
		<Carousel
			withControls={false}
			slidesToScroll="auto"
			slideSize="auto"
			slideGap={8}
			align="start"
			w="100%"
		>
			{(data ?? timeItems).map((el, idx) => (
				<Carousel.Slide key={el.label}>
					<SliderButton
						active={currentTab !== idx}
						onClick={() => handleAddTime(el.value ?? 0, idx)}
						disabled={disabled}
					>
						{el.label}
					</SliderButton>
				</Carousel.Slide>
			))}
		</Carousel>
	);
};
